
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import React, { useEffect } from 'react';
import ChatService from '../../services/chatservice';
import useMonitorAPIService from '../../services/monitorapiservice';
import Chat from './chat';
import { addChat, addMessage, closeChat } from '../../redux/chatSlice';
import ChatWindow from './chatwindow';
function ChatsList(props) {

    const { t } = useTranslation();
    const { getChatUrl } = useMonitorAPIService();

    useEffect(() => {

        getChatUrl(props.token, async (url) => {
            await ChatService.connect(url.data.message, props.id);
            ChatService.registerInitChat(props.addChat);
            ChatService.registerAddMessage(props.addMessage);
            ChatService.registerChatClosed(props.closeChat);
        });

        return () => {
            // component unmounts
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="card w-100 rounded-0 border-0">
            <div className="card-header pe-5">
                <h3 className="card-title align-items-start flex-column text-primary">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("messages")} /> {t("chats")} </span>
                </h3>
                <div className="card-toolbar">
                    <div className="me-2">
                        <button type="button" className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary" onClick={props.toggleChat} >
                            <FontAwesomeIcon size="lg" icon={duotone("arrow-right")} />
                        </button>
                    </div>
                </div>
            </div>
            <div className="card-body" style={{ padding: "0px" }}>

                {
                    !props.selectedChat &&
                    <div>
                        {
                            props.chats.map(v => {
                                return <Chat key={v.id} chat={v}></Chat>
                            })
                        }
                    </div>

                }
                {
                    props.selectedChat &&
                    <ChatWindow></ChatWindow>
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        id: state.supervisor.id,
        chats: state.chat.chats,
        selectedChat: state.chat.selectedChat
    };
};

export default connect(mapStateToProps, { addChat, addMessage, closeChat })(ChatsList);